<template>
  <v-container>
    <film-table :query="this.$route.query" />
  </v-container>
</template>

<script>
import FilmTable from "@/components/films/FilmTable"

export default {
  name: "Films",
  components: {
    FilmTable,
  },
}
</script>
